export const tzs = (n: number | null | undefined) => `TZS ${Math.round(n ?? 0).toLocaleString("en-US")}`;

const DATE_OPTS: Intl.DateTimeFormatOptions = { timeZone: "Africa/Dar_es_Salaam", day: "numeric", month: "short", year: "numeric" };

export function formatDate(v: string | Date | null | undefined, lang: "en" | "sw" = "en"): string {
  if (!v) return "—";
  return new Date(v).toLocaleDateString(lang === "sw" ? "sw-TZ" : "en-GB", DATE_OPTS);
}

export function formatDateTime(v: string | Date | null | undefined, lang: "en" | "sw" = "en"): string {
  if (!v) return "—";
  return new Date(v).toLocaleString(lang === "sw" ? "sw-TZ" : "en-GB", { ...DATE_OPTS, hour: "2-digit", minute: "2-digit" });
}

/** "YYYY-MM-DD" (date input) ↔ "DD-MM-YYYY" (what the API stores). */
export const toApiDate = (iso: string) => (iso ? iso.split("-").reverse().join("-") : "");
export const fromApiDate = (d: string | null) => (d ? d.split("-").reverse().join("-") : "");

/** "5 min ago" / "dakika 5 zilizopita", falling back to the date after a week. */
export function timeAgo(v: string | Date, lang: "en" | "sw" = "en"): string {
  const s = Math.round((Date.now() - new Date(v).getTime()) / 1000);
  const rtf = new Intl.RelativeTimeFormat(lang === "sw" ? "sw" : "en", { numeric: "auto" });
  if (s < 60) return rtf.format(0, "second");
  if (s < 3600) return rtf.format(-Math.floor(s / 60), "minute");
  if (s < 86400) return rtf.format(-Math.floor(s / 3600), "hour");
  if (s < 7 * 86400) return rtf.format(-Math.floor(s / 86400), "day");
  return formatDate(v, lang);
}

/** Digits only, for tel:/wa.me links. */
export const phoneDigits = (p: string) => p.replace(/[^\d]/g, "");
